module.exports = __webpack_public_path__ + "static/media/small-logo.24810466.svg";